import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'era-title',
  templateUrl: './title.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./title.component.scss'],
})
export class TitleComponent {
  readonly isDetail = input(false);
}
